import {Component} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {SessionStorageService} from './shared/services/session-storage.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css']
})

export class AppComponent {
    title = 'Vending Machine';
    default_language = 'en';

    constructor(private translate: TranslateService, private sessionStorageService: SessionStorageService) {

        const languageSession = sessionStorageService.getLanguageSession();
        this.default_language = languageSession;

        sessionStorageService.setLanguageSession(this.default_language == null ? 'en' : languageSession);

        translate.setDefaultLang(sessionStorageService.getLanguageSession());
        translate.use(sessionStorageService.getLanguageSession());
    }
}
